/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_ModelInputs */

const zh_analytics_model = /** @type {(inputs: Analytics_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模型`)
};

const en_analytics_model = /** @type {(inputs: Analytics_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const es_analytics_model = /** @type {(inputs: Analytics_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo`)
};

/**
* | output |
* | --- |
* | "Model" |
*
* @param {Analytics_ModelInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const analytics_model = /** @type {((inputs?: Analytics_ModelInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_ModelInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_model(inputs)
	if (locale === "en") return en_analytics_model(inputs)
	return es_analytics_model(inputs)
});